import CastModal from './cast/modal.es6';
import Anchor from "./cast/anchor.es6";

const modal = new CastModal();
const anchor = new Anchor();